// taken from here: https://github.com/eMarketer/em-jwt-reader/blob/master/src/jwt-decode.js

import { Buffer } from 'buffer';

/**
 * Decodes a JSON Web Token (JWT) and returns the decoded payload.
 * @param {string} token - The JWT to decode.
 * @returns {object|null} - The decoded object payload if decoding is successful, otherwise null.
 */
export function jwtDecode(token: string | null | undefined) {
  if (!token) {
    return null;
  }

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // OLD: base64Url.replace('-', '+').replace('_', '/');
    const obj = JSON.parse(Buffer.from(base64, 'base64').toString('binary')); //JSON.parse(atob(base64));
    return obj;
  } catch (error) {
    // TODO: log the error here
    return null;
  }
}
